/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useContext } from 'react';
import {
    bool, func,  instanceOf,  object, string,
} from 'prop-types';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core';
import GuidedNavModalView from './GuidedNavModalView';
import EdsGuideNavModalView from './EdsGuideNavModalView';
import GfAndGnavAbTestContext from '../../../../../GraphqlCoreBrowsing/GfAndGnavAbTestContext';
import { getFeatureFlag } from '../../../../../../../../state/ducks/App/ducks/Config/Config-Selectors';

const GuideNavModal = ({
    currentAddress,
    handleButtonSubmit,
    guidedNavFormData,
    showQasModel,
    handleLocationFormChange,
    handleAddressChange,
    addressFieldOnFocus,
    addressFieldOnBlur,
    handleKeyDown,
    qasSuggestions,
    onSubmitCheck,
    isOpen,
    closeModal,
    getAddressInformation,
    hideQasModel,
    zipValid,
    selectedLocationType,
    loadGoogleMaps,
    trackEvent,
    zipDerivedFromGoogleMaps,
    activeABTests,
    guidedNavModalIsOpen,
    guidedNavModalEdsActivated,
}) => {
    const isGnavEdsEnabled = useSelector(getFeatureFlag('is-gnav-eds-enabled'));
    const gnavAbTestContext = useContext(GfAndGnavAbTestContext);
    if ((isGnavEdsEnabled || gnavAbTestContext?.gfAndGnavEdsAbTestVariant) && guidedNavModalEdsActivated) {
        return (
            <EdsGuideNavModalView
                guidedNavFormData={guidedNavFormData}
                isOpen={isOpen}
                handleAddressChange={handleAddressChange}
                handleLocationFormChange={handleLocationFormChange}
                currentAddress={currentAddress}
                getAddressInformation={getAddressInformation}
                addressFieldOnFocus={addressFieldOnFocus}
                handleButtonSubmit={handleButtonSubmit}
                closeModal={closeModal}
                zipValid={zipValid}
                onSubmitCheck={onSubmitCheck}
                qasSuggestions={qasSuggestions}
                showQasModel={showQasModel}
                hideQasModel={hideQasModel}
                handleKeyDown={handleKeyDown}
                addressFieldOnBlur={addressFieldOnBlur}
            />
        );
    }
    return (
        guidedNavModalIsOpen && (activeABTests?.loaded || activeABTests?.timeout) && (
            <GuidedNavModalView
                guidedNavFormData={guidedNavFormData}
                isOpen={isOpen}
                handleAddressChange={handleAddressChange}
                selectedLocationType={selectedLocationType}
                handleLocationFormChange={handleLocationFormChange}
                currentAddress={currentAddress}
                getAddressInformation={getAddressInformation}
                loadGoogleMaps={loadGoogleMaps}
                addressFieldOnFocus={addressFieldOnFocus}
                handleButtonSubmit={handleButtonSubmit}
                closeModal={closeModal}
                zipValid={zipValid}
                onSubmitCheck={onSubmitCheck}
                trackEvent={trackEvent}
                zipDerivedFromGoogleMaps={zipDerivedFromGoogleMaps}
                qasSuggestions={qasSuggestions}
                showQasModel={showQasModel}
                hideQasModel={hideQasModel}
                handleKeyDown={handleKeyDown}
            />

        )
    );
};
GuideNavModal.propTypes = {
    guidedNavFormData: object.isRequired,
    currentAddress: string.isRequired,
    isOpen: bool.isRequired,
    handleAddressChange: func.isRequired,
    addressFieldOnBlur: string.isRequired,
    handleLocationFormChange: func.isRequired,
    getAddressInformation: func.isRequired,
    addressFieldOnFocus: func.isRequired,
    handleButtonSubmit: func.isRequired,
    onSubmitCheck: bool.isRequired,
    closeModal: func.isRequired,
    qasSuggestions: object,
    showQasModel: bool,
    hideQasModel: func,
    handleKeyDown: func.isRequired,
    zipValid: bool.isRequired,
    selectedLocationType: string.isRequired,
    trackEvent: func.isRequired,
    loadGoogleMaps: bool.isRequired,
    zipDerivedFromGoogleMaps: string.isRequired,
    activeABTests: object.isRequired,
    guidedNavModalIsOpen: bool,
    guidedNavModalEdsActivated: bool,
};

GuideNavModal.defaultProps = {
    qasSuggestions: {},
    showQasModel: false,
    hideQasModel: () => { },
    guidedNavModalIsOpen: false,
    guidedNavModalEdsActivated: false,
};

export default GuideNavModal;
